export { default as Tabs } from './tabs';
export type { TabsProps } from './tabs';

export * from './tabs.core';
